

import workLocationManagerReducer from './WorkLocationManagerReducer'
export { workLocationManagerReducer }

export * from './WorkLocationManagerActions'



// WEBPACK FOOTER //
// ./src/store/work-location-manager/index.js